module.exports = __webpack_public_path__ + "static/media/beatles.330e1374.png";